import {ModifiUiApp} from '@modifi/ui'
import {connect} from '@modifi/redux'
import React, {useEffect} from 'react'
import Cookies from 'js-cookie'
import PropTypes from 'prop-types'
import {aChangeLocale} from '@modifi/plugin-i18n'
import {GlobalStyles} from '../../../styles'

const MinimalLayout = ({children, locale, changeLocale}) => {
  useEffect(() => {
    // @todo compatibility - use en_GB for now instead of en_US
    if (!locale || locale === 'en_US') {
      changeLocale('en_GB')
    } else {
      changeLocale(locale)
    }
  }, [locale, changeLocale])
  return (
    <ModifiUiApp backgroundColor="transparent">
      {children}
      <GlobalStyles />
    </ModifiUiApp>
  )
}

MinimalLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.object]),
  locale: PropTypes.string,
  changeLocale: PropTypes.func.isRequired,
}

MinimalLayout.defaultProps = {
  children: null,
  locale: Cookies.get('modifi-locale'),
}

const mapDispatchToProps = {
  changeLocale: aChangeLocale,
}

export default connect(null, mapDispatchToProps)(MinimalLayout)
